<template>
  <div>
    <div class="m-background m-background--media-1"></div>
    <img  class="leap" src="../assets/images/logos/leap-skills-black.png">
    <div class="l-container l-pad">
      <img class="l--right" src="../assets/images/students/students__all-2.png">
      <img src="../assets/images/logos/logo__unite.png"  class="unite-logo" />
      <h1 class="l__splash">Are you ready for the leap?</h1>
      <p class="l__splash">To access the facilitator resources and start the game, please press enter</p>
      <router-link class="m-btn m-btn--left m-btn__primary"
        :to="{ name: 'start' }">Enter &nbsp;<span class="m-btn__arrow" style="display:inline-block; margin-top: -0.4em;"></span></router-link>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import MainFooter from '../components/MainFooter'
export default {
  name: 'Students',
  components: {
    MainFooter
  }
}
</script>

<style scoped lang='scss'>
img.l--right {
  width: 66%;
  right:-40px;
  bottom:-1px;
}

img.leap {
  width: 150px;
  height: auto;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 125px;
}
.unite-logo {
  width:250px;
}

@media (max-width: 899px) {
img.l--right {
  width:45%;
  right:70px;
  bottom:-1px;
}

img.leap {
  width:60px;
  height: auto;
  position: absolute;
  top: 10px;
  right: 20px;
}
.unite-logo {
  width:15%;
}
.l__splash {
    width:45%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Students.vue